import { render, staticRenderFns } from "./vipStatistics.vue?vue&type=template&id=c27d0026&scoped=true&"
import script from "./vipStatistics.vue?vue&type=script&lang=js&"
export * from "./vipStatistics.vue?vue&type=script&lang=js&"
import style0 from "./vipStatistics.vue?vue&type=style&index=0&id=c27d0026&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27d0026",
  null
  
)

export default component.exports